module.exports = __webpack_public_path__ + "img/bitbox.26296ff7.svg";